import { render, staticRenderFns } from "./Game2-10.vue?vue&type=template&id=df8e0fae&scoped=true&"
import script from "./Game2-10.vue?vue&type=script&lang=js&"
export * from "./Game2-10.vue?vue&type=script&lang=js&"
import style0 from "./Game2-10.vue?vue&type=style&index=0&id=df8e0fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8e0fae",
  null
  
)

export default component.exports